module.exports = __webpack_public_path__ + "img/person-pink.ba2b7799.png";